export const CASETYPES_FETCHING = 'CASETYPES_FETCHING';
export const CASETYPES_FETCHED = 'CASETYPES_FETCHED';
export const CASETYPES_FETCH_ERROR = 'CASETYPES_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/state/caseTypes/types.js